module.exports = __webpack_public_path__ + "media/images/awards-4-6b63325ae0561d4366d986d54e14b776.jpg";